import classNames from 'classnames';
import { useCallback, useState } from 'react';

import GravityForm from './GravityForm';
import GravityFormSuccess from './GravityFormSuccess';
import { GravityFormsFragmentFragment } from '../../__generated__/graphql';
import Heading2 from '../../components/Text/Heading2';
import Paragraph from '../../components/Text/Paragraph';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

import style from './gravity-forms.module.css';

const GravityForms: ContentBlock<GravityFormsFragmentFragment> = ({ fragment }) => {
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSuccess = useCallback(() => {
    setIsSuccess(true);
  }, []);

  const contentBlockProps = fragment.attributes;

  if (!contentBlockProps?.form) {
    return null;
  }

  return (
    <Section
      backgroundColor="black"
      id={null}
      innerContainerClassName={style.gravityForm}
    >
      <div
        className={classNames(
          style.successContainer,
          style.animated,
          {
            [style.hidden]: !isSuccess,
            [style.inFromRight]: !isSuccess,
          },
        )}
      >
        {isSuccess && (
          <GravityFormSuccess
            confirmations={contentBlockProps.form.confirmations}
          />
        )}
      </div>

      <div
        className={classNames(
          style.gravityFormTextContainer,
          style.animated,
          {
            [style.hidden]: isSuccess,
            [style.outToLeft]: isSuccess,
          },
        )}
      >
        <Heading2>
          {contentBlockProps.form.title}
        </Heading2>

        {contentBlockProps.form.description && (
          <Paragraph>
            {contentBlockProps.form.description}
          </Paragraph>
        )}
      </div>

      <div
        className={classNames(
          style.formContainer,
          style.animated,
          {
            [style.hidden]: isSuccess,
            [style.outToLeft]: isSuccess,
          },
        )}
      >
        <GravityForm
          form={contentBlockProps.form}
          onSuccess={handleSuccess}
        />
      </div>
    </Section>
  );
};

export default GravityForms;
